<section class="pt-80 pb-80 secondary-footer" *ngIf="width == 'FULL'">
    <div class="container">
        <div class="row">
            <div class="col-12 text-center text-white">
                <h1>{{ title }}</h1>
                <p class="mx-auto d-block">{{ subtitle }}</p>
                <a [routerLink]="url">
                    <button type="button" class="btn btn-primary btn-lg font-weight-bold mt-4 font-size-16">{{ button }}</button>
                </a>
            </div>
        </div>
    </div>
</section>

<div class="container secondary-footer pb-80 pt-80" *ngIf="width == 'CONSTRAINED'">
    <div class="row">
        <div class="col-12 text-center text-white">
            <h1>{{ title }}</h1>
            <p class="mx-auto d-block" *ngIf="subtitle">{{ subtitle }}</p>
            <a [routerLink]="url" *ngIf="url">
                <button type="button" class="btn btn-primary btn-lg font-weight-bold mt-4 font-size-16">{{ button }}</button>
            </a>
        </div>
    </div>
</div>